/**
 * Extracts a description from a code description object, trying multiple possible fields
 * and falling back to 'N/A' if none are found
 * @param codeDescription The code description object from the code descriptions dictionary
 * @returns The extracted description or 'N/A' if none found
 */
export const extractCodeDescriptionForCode = (codeDescription: any): string => {
  if (!codeDescription) {
    return 'N/A';
  }
  return (
    codeDescription.descriptor ||
    codeDescription.description ||
    codeDescription.shortDescription ||
    'N/A'
  );
};

export const extractShortDescriptionForCode = (
  codeDescription: any
): string => {
  if (!codeDescription) {
    return 'N/A';
  }
  return codeDescription.shortDescription || 'N/A';
};
